import { useMediaQuery } from "@mui/material";
import { useMemo } from "react";

const useMediaBreakpoints = () => {
  const smallScreens = useMediaQuery("(max-height:750px)");
  const xsScreens = useMediaQuery("(max-height:600px)");

  const maxHeightForPreviewPlayer = useMemo(() => {
    if (xsScreens) {
      return 330;
    }
    if (smallScreens) {
      return 450;
    }
    return 450;
  }, [smallScreens, xsScreens]);
  return {
    smallScreens,
    maxHeightForPreviewPlayer
  };
};

export default useMediaBreakpoints;
